/*
 * Jira Ticket:
 * Created Date: Tue, 10th Mar 2020, 14:55:18 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const registerUserMutation = gql`
  mutation createUser($input: CreateUserInput!) {
    data: createUser(input: $input) {
      id
      givenName
      familyName
      position
      email
      certificateNumber
    }
  }
`;

const registerUser = async ({ publicClient, params }) => {
  try {
    const response = await publicClient.mutate({
      mutation: registerUserMutation,
      variables: {
        input: params,
      },
    });
    return response.data;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};

export default registerUser;
